module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stock-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-freight",
      "md-label": "Грузы",
      "to": {
        name: 'Freights'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-itineraries",
      "md-label": "Маршрутные листы",
      "to": {
        name: 'Itineraries'
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c49dd7c2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/stock-menu.vue
// module id = 1254
// module chunks = 0